module.exports = __webpack_public_path__ + "img/paint-roller.52b0692a.svg";